export const encodeBase64Url = (value: string | Buffer) =>
  Buffer
    .from(value)
    .toString('base64url')
